/// <amd-module name="TFS/Admin/Views/ProjectPermissions/Constants/Constants" />

export const AssignmentsLookUpBatchSize: number = 50;
